import Axios from "Services/Auth/AxiosInterceptors";

export const GetMailOrderPharmacyDefinitions = async () => {
  const { data: { result } } = await Axios.get("/pharmacy/mail-order/admin/list");
  return result;
};

export const PreviewMailOrderPharmacyDefinition = async (payload) => {
  const { data: { result } } = await Axios.post("/pharmacy/mail-order/admin/preview", payload);
  return result;
};

export const CreateMailOrderPharmacyDefinition = async (payload) => {
  const { data: { result } } = await Axios.post("/pharmacy/mail-order/admin/create", payload);
  return result;
};

export const UpdateMailOrderPharmacyDefinition = async (id, payload) => {
  const { data: { result } } = await Axios.patch(`/pharmacy/mail-order/admin/${id}`, payload);
  return result;
};

export const SetMailOrderPharmacyDefinitionActive = async (id, active) => {
  const { data: { result } } = await Axios.patch(`/pharmacy/mail-order/admin/${id}/active`, { active });
  return result;
};

export const ResolveMailOrderPharmacyDefinition = async (id) => {
  const { data: { result } } = await Axios.post(`/pharmacy/mail-order/admin/${id}/resolve`);
  return result;
};

